<ng-template [ngIf]="!fascicolo?.rifiuto && showRifiuto">
<div class="standardpanel">
	<div class="titleblock">
		<h3 class="title1level">Rifiuto {{ oggettoRifiuto }}</h3>
	</div>
	<form>
		<div class="container_dati_generali">
			<p class="col-sm-12">
				<label for="rifiuto_competenza">Motivo rifiuto</label>
				<span class="mandatory">*</span>
				<textarea class="form-control" name="rifiuto_competenza"
					id="rifiuto_competenza"
					placeholder="Inserisci il motivo del rifiuto"
					[(ngModel)]="motivoRifiuto"></textarea>
			</p>
		</div>
		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		<div class="row">
			<p
				submitButton [disabled]="!motivoRifiuto || (motivoRifiuto && motivoRifiuto.trim().length == 0)"
				class="col-sm-3 col-xs-3 col-xs-offset-9 col-sm-offset-9"
				[labelButton]="'Rifiuta'" (click)="rifiutaCallback(motivoRifiuto)"></p>
		</div>
	</form>
</div>
</ng-template>
<ng-template [ngIf]="fascicolo?.rifiuto && showRifiuto">
<div class="standardpanel">
	<div class="container_dati_generali">
		<p>L'operazione &egrave; stata rifiutata da {{
			fascicolo.rifiuto.username }} con il seguente motivo:</p>
		<p>{{ fascicolo.rifiuto.motivo }}</p>
	</div>
</div>
</ng-template>